import React from 'react';
import { colors } from '@guryou/colors';

const CategoryTag = ({ name, size = 'sm', variant = 'default', className = '' }) => {
  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-3 py-1 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-5 py-2 text-base',
  };

  const variantStyles = {
    default: {
      backgroundColor: colors.carouselPink,
      color: colors.mineShaft,
    },
    secondary: {
      backgroundColor: colors.mercury,
      color: colors.mineShaft,
    },
    primary: {
      backgroundColor: colors.mandy,
      color: colors.white,
    },
  };

  return (
    <span className={`inline-block rounded-full font-medium ${sizeClasses[size]} ${className}`} style={variantStyles[variant]}>
      {name}
    </span>
  );
};

export default CategoryTag;
